import type { Instance } from 'flatpickr/dist/types/instance';
import type { Plugin } from 'flatpickr/dist/types/options';

interface YearDropdownPluginOptions {
  minYear?: number;
  maxYear?: number;
}

const yearDropdownPluginFactory = ({
  minYear = new Date().getFullYear() - 50,
  maxYear = new Date().getFullYear() + 50,
}: YearDropdownPluginOptions = {}): Plugin => {
  return (fp: Instance) => {
    const yearSelect = document.createElement('select');
    yearSelect.classList.add('flatpickr-year-dropdown');

    for (let year = minYear; year <= maxYear; year++) {
      const option = new Option(year.toString(), year.toString());
      yearSelect.add(option);
    }

    yearSelect.addEventListener('change', () => {
      const selectedYear = parseInt(yearSelect.value, 10);
      fp.changeYear(selectedYear);
    });

    const syncYearDropdown = () => {
      if (yearSelect.value !== fp.currentYear.toString()) {
        yearSelect.value = fp.currentYear.toString();
      }
    };

    const handleMonthChange = (selectedDates: Date[], _dateStr: string, instance: Instance) => {
      const selectedDate = selectedDates[0];
      if (selectedDate) {
        const newDate = new Date(
          selectedDate.getFullYear(),
          instance.currentMonth,
          selectedDate.getDate(),
        );
        instance.setDate(newDate, false);
      }
      syncYearDropdown();
    };

    const handleYearChange = (selectedDates: Date[], _dateStr: string, instance: Instance) => {
      const selectedDate = selectedDates[0];

      if (selectedDate) {
        const newDate = new Date(
          instance.currentYear,
          instance.currentMonth,
          selectedDate.getDate(),
        );
        instance.setDate(newDate, false);
      }
    };

    return {
      onReady: () => {
        syncYearDropdown();

        const yearElement = fp.currentYearElement as HTMLElement | null;
        const monthNav = yearElement?.parentElement;
        if (yearElement && monthNav) {
          yearElement.style.display = 'none';
          monthNav
            .querySelectorAll<HTMLElement>('.arrowUp, .arrowDown')
            .forEach((arrow) => (arrow.style.display = 'none'));

          monthNav.appendChild(yearSelect);
        }
      },
      onMonthChange: handleMonthChange,
      onYearChange: handleYearChange,
      onChange: syncYearDropdown,
      onOpen: syncYearDropdown,
    };
  };
};

export default yearDropdownPluginFactory;
